import RequestComments from '@oncolens/oncolens-ui/lib/components/Collaboration/RequestComments';
import { useCollaborationComments } from '@oncolens/oncolens-ui/lib/hooks/collaboration-comments/useCollaborationComments';
import React from 'react';
import RequestSection from './NewRequest/RequestSection';

interface CommentsSectionProps {
	requestId: string;
}

export const CommentsSection = ({ requestId }: CommentsSectionProps) => {
  const { data, isLoading } = useCollaborationComments(requestId);

  return (
    <RequestSection title="History" className="print:hidden">
      <RequestComments comments={data} isLoading={isLoading} />
    </RequestSection>
  );
};
